import React from 'react';
import ActionsMenu, {
    ActionsMenuProps,
} from '../../common/Navigation/ActionsMenu';
import CcSnapshotRepository, {
    CcSnapshotRepositoryType,
} from '../../services/models/CcSnapshotRepository';
import SnapshotRepositoryDeleteActionButton from './SnapshotRepositoryDeleteActionButton';

export default SnapshotRepositoryActionsMenu;
export type SnapshotRepositoryActionsMenuProps = ActionsMenuProps & {
    repository: CcSnapshotRepository;
    clusterId: number;
    onActionPerformed?: () => void;
};

function SnapshotRepositoryActionsMenu({
    repository,
    clusterId,
    onActionPerformed,
    ...rest
}: SnapshotRepositoryActionsMenuProps) {
    const handleActionSuccess = () => {
        onActionPerformed?.();
    };
    return (
        <ActionsMenu
            items={
                repository?.name &&
                repository.type !== CcSnapshotRepositoryType.FS &&
                clusterId
                    ? [
                          {
                              key: 'delete',
                              waitForConfirm: true,
                              label: (
                                  <SnapshotRepositoryDeleteActionButton
                                      repository={repository}
                                      clusterId={clusterId}
                                      onSuccess={handleActionSuccess}
                                  />
                              ),
                          },
                      ]
                    : []
            }
            {...rest}
        />
    );
}
